exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
